import { createResourceSelectors } from "src/redux_resources_v1";

// Constants
import { resourceNames } from "src/constants";

export const encountersResourceSelectors = createResourceSelectors(
  resourceNames.encounters
);
